import React, { Component } from 'react'
import EmailsStore from '../../stores/EmailsStore'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import LoadingWrapper from '../../components/LoadingWrapper'
import Toast from '../../components/Toast'
import { Button, Form, Grid } from 'semantic-ui-react'
import Input from '../../components/Forms/Input'
import Editor from '../../components/Forms/Editor'
import ModalUnsavedConfirmation from '../../components/ModalUnsavedConfirmation'
import PropTypes from 'prop-types'

@withRouter
@observer
class EmailsEditScreen extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (!props.match.params.emailCode) {
      props.history.goBack()
    }
    this.emailsStore = new EmailsStore()
    window.document.title = 'Modifier le courriel'
  }

  componentDidMount () {
    this.emailsStore.loadOne(this.props.match.params.emailCode)
  }

  componentWillUnmount () {
    this.emailsStore = null
  }

  handleSaveEmail = () => {
    this.emailsStore.save(this.props.match.params.emailCode).then(() => {
      this.props.history.push('/emails')
    })
  }

  render () {
    const { isLoading, isSaving, toasts, isDirty } = this.emailsStore
    return (
      <>
        <ModalUnsavedConfirmation
          when={isDirty}
          onSave={this.handleSaveEmail}
        />
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Input name='email.code' store={this.emailsStore} label='Code' readOnly />
                <Input name='email.subject' store={this.emailsStore} label='Sujet' />
                <Editor name='email.message' store={this.emailsStore} label='Message' />
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            <Button
              content='Enregistrer'
              primary
              onClick={this.handleSaveEmail}
            />
          </Grid.Column>
        </Grid>
      </>
    )
  }
}

export default EmailsEditScreen
